import { RootState } from '../core'

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const selectAuthToken = (state: RootState) => state.auth.token
export const selectPendingQuery = (state: RootState) => state.auth.pendingQuery
